import { PayloadAction, createSlice } from "@reduxjs/toolkit"

import { API_STATUS } from "../types"

import { ACTION_TYPE_PARENT, getInstrumentTypeCategory } from "./actions"
import { PropertySlice } from "./types"

const INITIAL_STATE: PropertySlice = {
  instrumentTypeCategory: [],
  status: API_STATUS.idle,
  isLoading: false,
  error: null
}

/* eslint-disable no-param-reassign */
export const propertySlice = createSlice({
  name: ACTION_TYPE_PARENT,
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getInstrumentTypeCategory.fulfilled, (state, action: PayloadAction<string[]>) => {
        state.status = API_STATUS.success
        state.instrumentTypeCategory = [...state.instrumentTypeCategory, ...action.payload]
      })
      .addCase(getInstrumentTypeCategory.pending, (state) => {
        state.status = API_STATUS.loading
      })
      .addCase(getInstrumentTypeCategory.rejected, (state, action: any) => {
        state.status = API_STATUS.failed
        // state.error = action?.error?.message
        state.error = action.payload
      })
  }
})

export default propertySlice.reducer
